BX.addCustomEvent("DevBxWebFormCreated", function(app) {
    app.component('devbx-webform-form-page-actions', {
        props: {
            formPageActions: {
                required: true,
            },
            page: {
                required: true,
            },
            disableActions: {
                default: false,
            },
        },
        emits: ['submit-form'],
        computed: {
            showPrevButton() {
                let pages = Object.values(this.$root.pages);

                return pages.indexOf(this.page) > 0;
            },
            hasNextButton() {
                let pages = Object.values(this.$root.pages);

                return pages.indexOf(this.page) < pages.length - 1;
            },
            showNextButton() {
                return this.hasNextButton && this.$root.checkCondition(this.page, this.page.config.nextButton, 'showCondition') !== false;
            },

            submitActions() {

                let result = [];

                if (this.hasNextButton)
                    return result;

                this.formPageActions.forEach(item => {
                    if (item.action === 'SUBMIT') {
                        result.push(item);
                    }
                });

                return result;
            },

            prevButtonCssClass()
            {
                let result = {};

                result['devbx-webform-button-disabled'] = this.disableActions;

                if (this.page.config.prevButton.cssClass.length)
                {
                    result[this.page.config.prevButton.cssClass] = true;
                }

                return result;
            },

            nextButtonCssClass()
            {
                let result = {};

                result['devbx-webform-button-disabled'] = this.disableActions;

                if (this.page.config.nextButton.cssClass.length)
                {
                    result[this.page.config.nextButton.cssClass] = true;
                }

                return result;
            },

            cssClass()
            {
                let result = {};

                switch (this.$root.webForm.settings.buttonsAlign)
                {
                    case 'CENTER':
                        result['devbx-webform-navigation-center'] = true;
                        break;
                    case 'RIGHT':
                        result['devbx-webform-navigation-right'] = true;
                        break;
                }

                if (this.$root.webForm.settings.navigationCssClass.length)
                {
                    result[this.$root.webForm.settings.navigationCssClass] = true;
                }

                return result;
            },
        },
        methods: {
            getActionCssClass(action)
            {
                let result = {};

                result['devbx-webform-button-disabled'] = this.disableActions;

                if (action.cssClass.length)
                {
                    result[action.cssClass] = true;
                }

                return result;
            },
        },
        template: `
    <div class="devbx-webform-navigation" :class="cssClass">
        <button class="devbx-webform-button"
            :class="prevButtonCssClass" 
            v-if="showPrevButton" @click.stop.prevent="$root.showPrevPage()">
            <span>{{page.config.prevButton.text}}</span>        
        </button>    

        <button class="devbx-webform-button devbx-webform-button-primary" 
            :class="nextButtonCssClass" 
            v-if="showNextButton" @click.stop.prevent="$root.showNextPage()">
            <span>{{page.config.nextButton.text}}</span>        
        </button>

        <button v-for="(action, index) in submitActions" :key="index" 
            class="devbx-webform-button devbx-webform-button-primary" 
            :class="getActionCssClass(action)" 
           @click.stop.prevent="$emit('submit-form', action)">
            <span v-if="!$root.submitAjax">{{action.title}}</span>        
            <span v-else class="devbx-webform-button-svg-icon devbx-webform-animation-rotate">
                    <svg viewBox="0 0 118.04 122.88">
                        <path d="M16.08,59.26A8,8,0,0,1,0,59.26a59,59,0,0,1,97.13-45V8a8,8,0,1,1,16.08,0V33.35a8,8,0,0,1-8,8L80.82,43.62a8,8,0,1,1-1.44-15.95l8-.73A43,43,0,0,0,16.08,59.26Zm22.77,19.6a8,8,0,0,1,1.44,16l-10.08.91A42.95,42.95,0,0,0,102,63.86a8,8,0,0,1,16.08,0A59,59,0,0,1,22.3,110v4.18a8,8,0,0,1-16.08,0V89.14h0a8,8,0,0,1,7.29-8l25.31-2.3Z"/>
                    </svg>            
            </span>
        </button>
    </div>
    `
    });
});